// Lookup options shared across the form & filters
export const SEED_UNITS = ["grams", "kilograms", "seed count", "litres", "ml"];

export const COLLECTION_STATUSES = [
  "draft",
  "collected",
  "in_storage",
  "in_propagation",
  "deposited_with_seed_bank",
  "archived",
];

export const COLLECTION_PURPOSES = [
  "Restoration",
  "Seed bank archive",
  "Research",
  "Cultural use",
  "Mine rehabilitation",
  "Carbon project",
  "Nursery propagation",
];

export const VISIBILITY_LEVELS = [
  { value: "public", label: "Public", helper: "Visible to all roles" },
  { value: "internal", label: "Internal", helper: "Visible to project partners and above" },
  { value: "restricted", label: "Restricted", helper: "Cultural authority approval required" },
];

export const PERMISSION_STATUSES = ["pending", "in_review", "approved", "conditional", "denied"];
export const RATING_5 = ["Very poor", "Poor", "Moderate", "Good", "Excellent"];
export const RISK_LEVELS = ["very_low", "low", "moderate", "high", "very_high"];
export const EXPOSURE_LEVELS = ["none", "low", "moderate", "high", "extreme"];
export const YES_NO = ["yes", "no", "unknown"];
export const ASPECTS = ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "flat"];
export const LANDFORMS = ["Coastal", "Floodplain", "Hill slope", "Ridge", "Riparian", "Plateau", "Valley", "Wetland", "Dune"];

export const TISSUE_TYPES = ["Leaf", "Seed", "Cambium", "Root tip", "Floral bud", "Whole plant"];
export const GENETIC_STATUSES = ["not_started", "sample_dispatched", "in_lab", "results_received", "archived"];

export const REPORT_TYPES = [
  { value: "provenance", label: "Seed provenance" },
  { value: "cultural", label: "Cultural permission" },
  { value: "climate", label: "Climate risk" },
  { value: "genetic", label: "Genetic sampling" },
  { value: "restoration", label: "Restoration suitability" },
  { value: "partner", label: "Project partner" },
];
